/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import ClearIcon from '@mui/icons-material/Clear';
import {Stack} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {FC, useState} from 'react';
import {MuiDateTimeRangePicker} from '../DateAndTimeRange/DateAndTimeRange';

export type DateRangeValue = [Date | null, Date | null];

interface DateRangePickerProps {
  onDateRangeSelected: (value: DateRangeValue) => void;
}

export const SuperDatePicker: FC<DateRangePickerProps> = ({onDateRangeSelected}) => {
  const [value, setValue] = useState<DateRangeValue>([null, null]);

  const handleDateChange = (newValue: DateRangeValue) => {
    if (!newValue) return;
    setValue(newValue);
    onDateRangeSelected(newValue);
  };

  const clearDateRange = () => {
    const clearedValue: DateRangeValue = [null, null];
    setValue(clearedValue);
    onDateRangeSelected(clearedValue);
  };

  return (
    <Stack spacing={1} direction={'row'} alignItems={'center'}>
      {(value[0] || value[1]) && (
        <IconButton onClick={clearDateRange} aria-label={'Clear Date Range'} title={'Clear'}>
          <ClearIcon />
        </IconButton>
      )}
      <MuiDateTimeRangePicker defaultValue={value} onAccept={handleDateChange} showShortcuts={false} />
    </Stack>
  );
};
